import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAddQuizMutation } from "../../../../features/quiz/quizApi";
import { useGetVideosQuery } from "../../../../features/videos/videosApi";
import SelectList from "../../../ui/SelectList";
import MessageToast from "../../../ui/MessageToast";

export default function AddQuiz() {
	const [question, setQuestion] = useState("");
	const [video_id, setVideoId] = useState("");
	const [options, setOptions] = useState([
		{ id: 1, option: "", isCorrect: false },
		{ id: 2, option: "", isCorrect: false },
		{ id: 3, option: "", isCorrect: false },
		{ id: 4, option: "", isCorrect: false },
	]);

	const { data: videos, isSuccess: isGetVideosQuerySuccess } =
		useGetVideosQuery() || {};

	let videosSelectOptions = [];
	if (isGetVideosQuerySuccess) {
		videosSelectOptions = videos.map((video) => ({
			id: video.id,
			text: video.title,
		}));
	}

	const navigate = useNavigate();
	const [
		addQuiz,
		{
			isLoading: isAddQuizRequestLoading,
			isError: isAddQuizError,
			isSuccess: isAddQuizSuccess,
		},
	] = useAddQuizMutation() || [];

	useEffect(() => {
		if (isAddQuizSuccess) {
			navigate("/admin/quizzes");
		}
	}, [isAddQuizSuccess, navigate]);

	const handleFormSubmit = (e) => {
		e.preventDefault();
		const videoTitle = videos.find((v) => v.id == video_id)?.title;

		let quizData = {
			question,
			video_id: Number(video_id),
			video_title: videoTitle,
			options,
		};
		addQuiz(quizData);
	};

	const handleOptionChange = (value, property, index) => {
		setOptions((prev) => {
			let newOptions = prev.map((o) => ({ ...o }));
			newOptions[index][property] = value;
			return newOptions;
		});
	};

	return (
		<section className="py-6 bg-primary place-items-center">
			<div className="mx-auto max-w-5xl px-5 lg:px-0">
				<div>
					<h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
						Add Quiz
					</h2>
				</div>
				<form onSubmit={handleFormSubmit} className="mt-8 space-y-6">
					<div className="rounded-md shadow-sm ">
						<div>
							<label className="font-bold">Question:</label>
							<input
								value={question}
								onChange={(e) => setQuestion(e.target.value)}
								id="question"
								name="question"
								type="question"
								autoComplete="question"
								required
								className="login-input rounded-t-md"
								placeholder="Write question"
							/>
						</div>
						<div className="mt-4">
							<label className="font-bold">
								Select video to attach:
							</label>
							<SelectList
								options={videosSelectOptions}
								value={video_id}
								setValue={setVideoId}
								defaultText="Select video"
								className="login-input rounded-t-md"
								required
							/>
						</div>
						<h2 className="mt-4 font-bold">Prepare options:</h2>

						<div className="options-container">
							<div className="option-sigle">
								<div className="option-tag">
									<span className="option-name">A</span>
									<span>
										<input
											checked={options[0].isCorrect}
											onChange={(e) =>
												handleOptionChange(
													!options[0].isCorrect,
													"isCorrect",
													0
												)
											}
											type="checkbox"
											className="option-checkbox"
										/>
										Is true
									</span>
								</div>
								<textarea
									value={options[0].option}
									onChange={(e) =>
										handleOptionChange(
											e.target.value,
											"option",
											0
										)
									}
									type="text"
									className="option-input"
									required
								/>
							</div>
							<div className="option-sigle">
								<div className="option-tag">
									<span className="option-name">B</span>
									<span>
										<input
											checked={options[1].isCorrect}
											onChange={(e) =>
												handleOptionChange(
													!options[1].isCorrect,
													"isCorrect",
													1
												)
											}
											type="checkbox"
											className="option-checkbox"
										/>
										Is true
									</span>
								</div>
								<textarea
									value={options[1].option}
									onChange={(e) =>
										handleOptionChange(
											e.target.value,
											"option",
											1
										)
									}
									type="text"
									className="option-input"
									required
								/>
							</div>
							<div className="option-sigle">
								<div className="option-tag">
									<span className="option-name">C</span>
									<span>
										<input
											checked={options[2].isCorrect}
											onChange={(e) =>
												handleOptionChange(
													!options[2].isCorrect,
													"isCorrect",
													2
												)
											}
											type="checkbox"
											className="option-checkbox"
										/>
										Is true
									</span>
								</div>
								<textarea
									value={options[2].option}
									onChange={(e) =>
										handleOptionChange(
											e.target.value,
											"option",
											2
										)
									}
									type="text"
									className="option-input"
									required
								/>
							</div>
							<div className="option-sigle">
								<div className="option-tag">
									<span className="option-name">D</span>
									<span>
										<input
											checked={options[3].isCorrect}
											onChange={(e) =>
												handleOptionChange(
													!options[3].isCorrect,
													"isCorrect",
													3
												)
											}
											type="checkbox"
											className="option-checkbox"
										/>
										Is true
									</span>
								</div>
								<textarea
									value={options[3].option}
									onChange={(e) =>
										handleOptionChange(
											e.target.value,
											"option",
											3
										)
									}
									type="text"
									className="option-input"
									required
								/>
							</div>
						</div>
					</div>

					<div className="flex justify-center">
						<button
							disabled={isAddQuizRequestLoading}
							type="submit"
							className="group relative flex justify-center py-2 px-4 border border-transparent  font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
						>
							Add
						</button>
					</div>
				</form>
			</div>

			{isAddQuizError && (
				<MessageToast
					message="There was an error while adding quiz!"
					type="error"
					delay={3000}
				/>
			)}
		</section>
	);
}
